import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { Events } from 'app/core/events';
import { ModalsService } from 'app/shared/modals.service';
import { logger } from '../../../../core/utils/console';
import { ArquivoAnalisado, ExameConfiance, ExameLaboratorio } from 'app/core/interfaces/pacient-info.interface';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { normalizeDateToT03UTC, resolveLaboratorioDataPadrao } from 'app/shared/laboratorio-data.utils';

@Component({
  selector: 'app-exames',
  templateUrl: './exames.component.html',
  styleUrls: ['./exames.component.scss', './../tabelas.scss']
})
export class ExamesComponent implements OnInit {

  displayedColumns: string[] = ['exame', 'res1', 'res2', 'res3'];dataSource = [];

  data1_tri: any = null;
  data2_tri: any = null;
  data3_tri: any = null;
  boolCarregarExames: boolean;

  arquivosPDFAnalisados: Array<{trimestre: number, label: string, id: string, exames: string[], data: any, status: string}> = [];
  loadingArquivoId: string | null = null;
  deletingArquivoId: string | null = null;

  @Input() exames_lab;
  @Input() examesLabArr;
  @Input() dum: string | Date = '';
  @Input() cartao_id: string;
  @Input() arquivosAnalisados: ArquivoAnalisado[] = [];

  @Input() edit_mode = true;
  @Input() organizacao;
  @Input() encerrado: boolean = false;

  @Output() alterar_celula = new EventEmitter();
  @Output() atualiza_exames = new EventEmitter();
  @Output() delete_celula = new EventEmitter();

  public tabcount: number[];

  constructor(
    public events: Events,
    private modalsService: ModalsService,
    private _apiGestaCard: APIGestaCardService
  ) { }

  ngOnInit() {

    this.tabcount = [0, 0, 0];

    this.boolCarregarExames = false;

    if (this.edit_mode) {

      this.CheckExames();

    }

    const exameBlackList = ['Protoparasitologia'];
    this.exames_lab = this.exames_lab.filter((item) => {
      
      if (exameBlackList.indexOf(item.name) > -1) { return false; }
      return true;

    });

    this.dataSource = this.exames_lab;
    this.ArrumarDatas(this.exames_lab);
    this._calcularArquivosPDF();

    this.events.unsubscribe('ChangeDataTrimestre'); // avoid loop
    this.events.subscribe('ChangeDataTrimestre', () => {
      
      this.data1_tri = null;
      this.data2_tri = null;
      this.data3_tri = null;
      this.ArrumarDatas(this.exames_lab);
      this._calcularArquivosPDF();

    });

  }

  CheckExames() {

    if (!Array.isArray(this.examesLabArr) || !this.examesLabArr.length) { return; }

    this.examesLabArr.map(exame => {
      let achou = false;
      this.exames_lab.map(obj => {
        if (obj.name == exame) { achou = true; }
      });
      if (!achou) { this.boolCarregarExames = true; }
    });

  }

  ArrumarDatas(exames) {

    exames.forEach(element => {

      if (element.datas.data1 && element.datas.data1 != '' && this.data1_tri == null) {
        this.data1_tri = element.datas.data1;
      }

      if (element.datas.data2 && element.datas.data2 != '' && this.data2_tri == null) {
        this.data2_tri = element.datas.data2;
      }

      if (element.datas.data3 && element.datas.data3 != '' && this.data3_tri == null) {
        this.data3_tri = element.datas.data3;
      }

    });

    this.aplicarDataTrimestrePorArquivoAI(exames);
    this.sincronizarDatasPersistidasPorArquivoAI(exames);

  }

  private sincronizarDatasPersistidasPorArquivoAI(exames: ExameLaboratorio[]): void {
    if (!Array.isArray(exames) || exames.length === 0) return;

    const aplicarDataTri = (tri: number, dataRef: any) => {
      const dataNormalizada = normalizeDateToT03UTC(dataRef);
      if (!dataNormalizada) return;

      exames.forEach((exame) => {
        if (!exame || !exame.datas) return;

        if (tri === 1 && exame.arquivo_res1) {
          exame.datas.data1 = dataNormalizada;
        }

        if (tri === 2 && exame.arquivo_res2) {
          exame.datas.data2 = dataNormalizada;
        }

        if (tri === 3 && exame.arquivo_res3) {
          exame.datas.data3 = dataNormalizada;
        }
      });
    };

    aplicarDataTri(1, this.data1_tri);
    aplicarDataTri(2, this.data2_tri);
    aplicarDataTri(3, this.data3_tri);
  }

  private aplicarDataTrimestrePorArquivoAI(exames: ExameLaboratorio[]): void {
    if (!Array.isArray(exames) || exames.length === 0) return;

    const laboratoriais = (this.arquivosAnalisados || []).filter(a => a.tipo === 'laboratorial');
    if (!laboratoriais.length) return;

    const dataDoArquivo = (arquivoId: string | null): any => {
      if (!arquivoId) return null;

      const arquivo = laboratoriais.find(a => a.id === arquivoId);
      if (!arquivo) return null;

      return normalizeDateToT03UTC(arquivo.data_realizacao);
    };

    const resolverDataTriAI = (tri: number): any => {
      const examesDoTri = exames.filter(e =>
        tri === 1 ? !!e.arquivo_res1 : tri === 2 ? !!e.arquivo_res2 : !!e.arquivo_res3
      );

      if (!examesDoTri.length) return null;

      const idsArquivo = Array.from(new Set(examesDoTri
        .map(e => tri === 1 ? e.arquivo_res1 : tri === 2 ? e.arquivo_res2 : e.arquivo_res3)
        .filter(id => !!id)));

      for (const id of idsArquivo) {
        const dataArquivo = dataDoArquivo(id as string);
        if (dataArquivo) return dataArquivo;
      }

      // Fallback final para cenários antigos sem data no arquivo
      const exameComData = examesDoTri.find(e =>
        tri === 1 ? !!e.datas.data1 : tri === 2 ? !!e.datas.data2 : !!e.datas.data3
      );

      if (!exameComData) return null;

      const dataExame = tri === 1
        ? exameComData.datas.data1
        : tri === 2
          ? exameComData.datas.data2
          : exameComData.datas.data3;

      return normalizeDateToT03UTC(dataExame);
    };

    const dataTri1 = resolverDataTriAI(1);
    const dataTri2 = resolverDataTriAI(2);
    const dataTri3 = resolverDataTriAI(3);

    if (dataTri1) this.data1_tri = dataTri1;
    if (dataTri2) this.data2_tri = dataTri2;
    if (dataTri3) this.data3_tri = dataTri3;

  }

  CarregarExames() {

    this.events.publish('CarregarExames');

  }

  async LerPDF() {
    try {
      this.events.publish('ExameLaboratorialIncluirPDF', { callback: (exames: ExameLaboratorio[]) => {
        this.exames_lab = exames;
        this.dataSource = this.exames_lab;
        
        this.data1_tri = null;
        this.data2_tri = null;
        this.data3_tri = null;
        this.ArrumarDatas(this.exames_lab);
        this._calcularArquivosPDF();
      }});
    } catch (error) {
      logger.error('Erro ao analisar PDF de exames:', error);
    }
  }

  TrocarData(trimestre) {

    this.alterar_celula.emit({ exame: null, trimestre: trimestre, anotherField: 'data' });

  }

  SalvarMudancas() {
    
  }

  AbrirModoEdicao(element, trimestre, anotherField?) {
    
    if (element.name == 'ABO/Rh') {

      this.alterar_celula.emit({ exame: element, trimestre: trimestre, allTrimestre: true, anotherField: anotherField });

    } else {

      this.alterar_celula.emit({ exame: element, trimestre: trimestre, anotherField: anotherField });
      
    }
  }

  RemoverExame(element) {

    this.delete_celula.emit({ exame: element });

  }

  private _calcularArquivosPDF(): void {
    const resultMap = new Map<string, {trimestre: number, label: string, id: string, exames: string[], data: any, status: string}>();
    const source = this.dataSource as ExameLaboratorio[];
    const laboratoriais = (this.arquivosAnalisados || []).filter(a => a.tipo === 'laboratorial');

    const labelPorTrimestre = (t: number) =>
      t === 1 ? '1º Trimestre' : t === 2 ? '2º Trimestre' : t === 3 ? '3º Trimestre' : '-';

    const triCampos = [
      { trimestre: 1, field: 'arquivo_res1' as keyof ExameLaboratorio, dataTri: this.data1_tri },
      { trimestre: 2, field: 'arquivo_res2' as keyof ExameLaboratorio, dataTri: this.data2_tri },
      { trimestre: 3, field: 'arquivo_res3' as keyof ExameLaboratorio, dataTri: this.data3_tri },
    ];

    const upsertArquivo = (item: {trimestre: number, label: string, id: string, exames: string[], data: any, status: string}) => {
      const current = resultMap.get(item.id);

      if (!current) {
        resultMap.set(item.id, {
          ...item,
          exames: Array.from(new Set(item.exames))
        });
        return;
      }

      const exames = Array.from(new Set((current.exames || []).concat(item.exames || [])));
      const shouldReplaceContext = item.trimestre >= current.trimestre;

      resultMap.set(item.id, {
        ...current,
        trimestre: shouldReplaceContext ? item.trimestre : current.trimestre,
        label: shouldReplaceContext ? item.label : current.label,
        data: shouldReplaceContext ? (item.data || current.data) : (current.data || item.data),
        status: item.status || current.status,
        exames
      });
    };

    if (laboratoriais.length > 0) {
      laboratoriais.forEach(arquivo => {
        // Scan todos os trimestres para encontrar exames que referenciam este arquivo
        let examesRef: string[] = [];
        let foundTrimestre = parseInt(arquivo.trimestre as string, 10) || 0;
        let foundData = arquivo.data_realizacao;

        for (const tri of triCampos) {
          const matches = source.filter(e => e[tri.field] === arquivo.id).map(e => e.name);
          if (matches.length > 0) {
            examesRef = examesRef.concat(matches);
            foundTrimestre = tri.trimestre;
            const exameComData = source.find(e => e[tri.field] === arquivo.id && (
              tri.trimestre === 1 ? !!e.datas.data1 : tri.trimestre === 2 ? !!e.datas.data2 : !!e.datas.data3
            ));

            const dataExame = exameComData
              ? (tri.trimestre === 1
                ? exameComData.datas.data1
                : tri.trimestre === 2
                  ? exameComData.datas.data2
                  : exameComData.datas.data3)
              : null;

            foundData = arquivo.data_realizacao || dataExame || tri.dataTri;
          }
        }

        upsertArquivo({
          trimestre: foundTrimestre,
          label: labelPorTrimestre(foundTrimestre),
          id: arquivo.id,
          exames: examesRef,
          data: foundData || arquivo.data_realizacao || null,
          status: arquivo.status
        });
      });
    } else {
      // Fallback: derivar dos exames (dados legacy sem arquivos_analisados)
      for (const tri of triCampos) {
        const idSet: Set<string> = new Set(
          source.filter(e => !!e[tri.field]).map(e => e[tri.field] as string)
        );
        idSet.forEach(id => {
          const exames = source.filter(e => e[tri.field] === id).map(e => e.name);
          upsertArquivo({ trimestre: tri.trimestre, label: labelPorTrimestre(tri.trimestre), id, exames, data: tri.dataTri, status: 'utilizado' });
        });
      }
    }

    this.arquivosPDFAnalisados = Array.from(resultMap.values());
  }

  UtilizarArquivo(arquivoId: string, trimestre: number): void {
    this.loadingArquivoId = arquivoId;
    this.events.publish('UtilizarArquivoLaboratorial', {
      arquivoId,
      trimestre,
      callback: (exames: ExameLaboratorio[]) => {
        this.exames_lab = exames;
        this.aplicarDataArquivoNoTrimestreSelecionado(arquivoId, trimestre, this.exames_lab);
        this.dataSource = this.exames_lab;
        this.data1_tri = null;
        this.data2_tri = null;
        this.data3_tri = null;
        this.ArrumarDatas(this.exames_lab);
        this._calcularArquivosPDF();
      },
      onFinish: () => {
        this.loadingArquivoId = null;
      }
    });
  }

  UtilizarArquivoAfterMenuClose(arquivoId: string, trimestre: number): void {
    setTimeout(() => this.UtilizarArquivo(arquivoId, trimestre));
  }

  AnalisarArquivo(arquivoId: string, trimestre: number): void {
    this.loadingArquivoId = arquivoId;
    this.events.publish('AnalisarArquivoLaboratorial', {
      arquivoId,
      trimestre,
      callback: (exames: ExameLaboratorio[]) => {
        this.exames_lab = exames;
        this.dataSource = this.exames_lab;
        this.data1_tri = null;
        this.data2_tri = null;
        this.data3_tri = null;
        this.ArrumarDatas(this.exames_lab);
        this._calcularArquivosPDF();
      },
      onFinish: () => {
        this.loadingArquivoId = null;
      }
    });
  }

  AnalisarArquivoAfterMenuClose(arquivoId: string, trimestre: number): void {
    setTimeout(() => this.AnalisarArquivo(arquivoId, trimestre));
  }

  private aplicarDataArquivoNoTrimestreSelecionado(arquivoId: string, trimestre: number, exames: ExameLaboratorio[]): void {
    if (!arquivoId || !Array.isArray(exames)) return;

    const arquivo = (this.arquivosAnalisados || []).find(a => a.id === arquivoId);
    if (!arquivo) return;

    const resultadoBruto = (arquivo as any).resultado;
    const examesResultado: ExameConfiance[] = Array.isArray(resultadoBruto)
      ? resultadoBruto
      : resultadoBruto && Array.isArray(resultadoBruto.exames)
        ? resultadoBruto.exames
        : [];

    const dataArquivo = resolveLaboratorioDataPadrao((arquivo as any).data_realizacao, examesResultado);
    if (!dataArquivo) return;

    if (trimestre === 1) this.data1_tri = dataArquivo;
    if (trimestre === 2) this.data2_tri = dataArquivo;
    if (trimestre === 3) this.data3_tri = dataArquivo;

    exames.forEach((exame) => {
      if (!exame || !exame.datas) return;

      if (trimestre === 1 && exame.arquivo_res1 === arquivoId) {
        exame.datas.data1 = dataArquivo;
      }

      if (trimestre === 2 && exame.arquivo_res2 === arquivoId) {
        exame.datas.data2 = dataArquivo;
      }

      if (trimestre === 3 && exame.arquivo_res3 === arquivoId) {
        exame.datas.data3 = dataArquivo;
      }
    });
  }

  async AbrirPDF(arquivoId: string): Promise<void> {
    this.events.publish('AbrirArquivoAnalisado', arquivoId);
  }

  async ExcluirPDF(arquivoId: string): Promise<void> {
    const confirmar = window.confirm('Deseja excluir este PDF analisado?');
    if (!confirmar) return;

    this.deletingArquivoId = arquivoId;

    try {
      await this._apiGestaCard.DeletarArquivoPDF(arquivoId);

      this.arquivosAnalisados = (this.arquivosAnalisados || []).filter(arquivo => arquivo.id !== arquivoId);
      this._calcularArquivosPDF();
    } catch (err) {
      logger.error('Erro ao excluir PDF analisado:', err);
    } finally {
      this.deletingArquivoId = null;
    }
  }

  noExistInDefault(exameName: string): boolean {
    if (!Array.isArray(this.examesLabArr) || !this.examesLabArr.length) return false;

    return this.examesLabArr.filter(exame => exame == exameName).length == 0;
  }

  ngOnChanges(changes: SimpleChanges) {
    
    this.dataSource = this.exames_lab;
    this.data1_tri = null;
    this.data2_tri = null;
    this.data3_tri = null;
    this.ArrumarDatas(this.exames_lab);
    this._calcularArquivosPDF();

    this.CheckExames();

  }

}
